// import React, { useEffect, useState } from 'react';
// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import { getBalanceSheet } from '@store/Finance/FinancialReports/FinancialReportsSlice';
// import Breadcrumb from '@components/Shared/Breadcrumb';
// import { Card, CardBody, CardHeader } from '@components/card/card';
// import { useTranslation } from 'react-i18next';
// import Loading from '@components/Shared/Loader/Loading';

// const BalanceSheet = () => {
//   const dispatch = useAppDispatch();
//   const { t, i18n } = useTranslation();
//   const [filter, setFilter] = useState({ startData: '', endData: '' });

//   useEffect(() => {
//     dispatch(
//       getBalanceSheet({
//         startDate: filter.startData,
//         endDate: filter.endData,
//       })
//     );
//   }, []);

//   const handleDispatch = () => {
//     dispatch(
//       getBalanceSheet({
//         startDate: filter.startData,
//         endDate: filter.endData,
//       })
//     );
//   };

//   const { BalanceSheet: data, loading, error } = useAppSelector((s) => s.FinancialReports);

//   const Assets = data?.list?.find((item) => item.accountNumber === '10000000');
//   const Liabilities = data?.list?.find((item) => item.accountNumber === '20000000');
//   const Equity = data?.list?.find((item) => item.accountNumber === '30000000');

//   //____________________________
//   var BcrumbList = [
//     {
//       name: 'Home',
//       link: ':moduleHome',
//     },
//     {
//       name: 'المركــز المالي',
//       link: null,
//     },
//   ];



//   return (
//     <>
//       <Breadcrumb BreadcrumbList={BcrumbList} PageName="المركــز المالي" />
//       <hr />

//       <div className="row mb-2">
//         <div className="col-lg-5">
//           <div className="input-group flex-nowrap">
//             <span className="input-group-text fw-bold">{t('من تاريـخ')}</span>
//             <div className="input-group">
//               <input
//                 type="date"
//                 autoComplete="off"
//                 className="form-control"
//                 value={filter.startData}
//                 onChange={(e) => {
//                   setFilter({ ...filter, startData: e.target.value });
//                 }}
//               />
//             </div>
//           </div>
//         </div>
//         <div className="col-lg-5">
//           <div className="input-group flex-nowrap">
//             <span className="input-group-text fw-bold">{t('إلى تاريـخ')}</span>
//             <div className="input-group">
//               <input
//                 type="date"
//                 autoComplete="off"
//                 className="form-control"
//                 value={filter.endData}
//                 onChange={(e) => {
//                   setFilter({ ...filter, endData: e.target.value });
//                 }}
//               />
//             </div>
//           </div>
//         </div>

//         <div className="col-lg-2">
//           <button className="btn btn-theme w-100" onClick={handleDispatch}>
//             {t('تحديث')}
//           </button>
//         </div>
//       </div>

//       <Loading loading={loading} error={error} Type="Dots">
//         <div className="row d-flex align-items-stretch">
//           <div className="col-12 col-lg-6 mb- ">
//             <Card className="h-100">
//               <CardHeader className="bg-theme bg-opacity-15">
//                 <h5 className="m-0">{Assets?.name2} </h5>
//               </CardHeader>
//               <CardBody>
//                 <div className="table-responsive">
//                   <table className="table text-nowrap">
//                     <thead className=" ">
//                       <tr>
//                         <th>كود الحساب </th>
//                         <th>اسم الحساب</th>
//                         <th>مدين (DR)</th>
//                         <th>دائن (CR)</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {Assets?.children?.map((category) => (
//                         <React.Fragment key={category.id}>
//                           <tr className="table-active fw-bold">
//                             <td>{category.accountNumber}</td>
//                             <td>{category.name2}</td>
//                             <td>{category.amounT_DR}</td>
//                             <td>{category.amounT_CR}</td>
//                           </tr>
//                           {category.children?.map((account) => (
//                             <tr key={account.id}>
//                               <td className="ps-4">{account.accountNumber}</td>
//                               <td>{account.name2}</td>
//                               <td>{account.amounT_DR}</td>
//                               <td>{account.amounT_CR}</td>
//                             </tr>
//                           ))}
//                         </React.Fragment>
//                       ))}
//                       {/* إجمالي الأصول */}
//                       <tr className="   fw-bold">
//                         <td colSpan={2} className="text-center ">
//                           إجمالي الأصول
//                         </td>
//                         <td>{Assets?.amounT_DR}</td>
//                         <td>{Assets?.amounT_CR}</td>
//                       </tr>
//                     </tbody>
//                   </table>
//                 </div>
//               </CardBody>
//             </Card>
//           </div>

//           <div className="col-12 col-lg-6 mb-">
//             <Card className="h-100">
//               <CardHeader className="bg-theme bg-opacity-15">
//                 <h5 className="m-0">الخصوم</h5>
//               </CardHeader>
//               <CardBody>
//                 <div className="table-responsive">
//                   <table className="table text-nowrap">
//                     <thead className=" ">
//                       <tr>
//                         <th>كود الحساب </th>
//                         <th>اسم الحساب</th>
//                         <th>مدين (DR)</th>
//                         <th>دائن (CR)</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {Liabilities?.children?.map((category) => (
//                         <React.Fragment key={category.id}>
//                           <tr className="table-active fw-bold">
//                             <td>{category.accountNumber}</td>
//                             <td>{category.name2}</td>
//                             <td>{category.amounT_DR}</td>
//                             <td>{category.amounT_CR}</td>
//                           </tr>
//                           {category.children?.map((account) => (
//                             <tr key={account.id}>
//                               <td className="ps-4">{account.accountNumber}</td>
//                               <td>{account.name2}</td>
//                               <td>{account.amounT_DR}</td>
//                               <td>{account.amounT_CR}</td>
//                             </tr>
//                           ))}
//                         </React.Fragment>
//                       ))}
//                       {/*  إجمالي الخصـوم */}
//                       <tr className="  fw-bold">
//                         <td colSpan={2} className="text-center">
//                           إجمالي الخصـوم
//                         </td>
//                         <td>{Liabilities?.amounT_DR}</td>
//                         <td>{Liabilities?.amounT_CR}</td>
//                       </tr>
//                     </tbody>
//                   </table>
//                 </div>
//               </CardBody>

//               <CardHeader className="bg-theme bg-opacity-15">
//                 <h5 className="m-0">حقوق الملكيـة</h5>
//               </CardHeader>
//               <CardBody>
//                 <div className="table-responsive">
//                   <table className="table text-nowrap">
//                     <thead className=" ">
//                       <tr>
//                         <th>رقم الحساب</th>
//                         <th>اسم الحساب</th>
//                         <th>مدين (DR)</th>
//                         <th>دائن (CR)</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {Equity?.children?.map((category) => (
//                         <React.Fragment key={category.id}>
//                           <tr className="table-active fw-bold">
//                             <td>{category.accountNumber}</td>
//                             <td>{category.name2}</td>
//                             <td>{category.amounT_DR}</td>
//                             <td>{category.amounT_CR}</td>
//                           </tr>
//                           {category.children?.map((account) => (
//                             <tr key={account.id}>
//                               <td className="ps-4">{account.accountNumber}</td>
//                               <td>{account.name2}</td>
//                               <td>{account.amounT_DR}</td>
//                               <td>{account.amounT_CR}</td>
//                             </tr>
//                           ))}
//                         </React.Fragment>
//                       ))}

//                       <tr className="  fw-bold">
//                         <td colSpan={2} className="text-center">
//                           إجمالي حقوق الملكيـة
//                         </td>
//                         <td>{Equity?.amounT_DR}</td>
//                         <td>{Equity?.amounT_CR}</td>
//                       </tr>
//                     </tbody>
//                   </table>
//                 </div>
//               </CardBody>
//             </Card>
//           </div>
//         </div>

//         <div className="row d-flex align-items-stretch mt-2">
//           <div className="col-12 col-lg-6 mb-">
//             <Card className="h-100">
//               <CardBody className="d-flex justify-content-between align-items-center">
//                 <span className="text-muted fs-5 fw-bold">إجمالي الأصول</span>
//                 <span className="text-theme fs-4 fw-bold">00000</span>
//               </CardBody>
//             </Card>
//           </div>

//           <div className="col-12 col-lg-6 mb-">
//             <Card className="h-100">
//               <CardBody className="d-flex justify-content-between align-items-center">
//                 <span className="text-muted fs-5 fw-bold"> إجمالي الخصوم وحقوق الملكــية</span>
//                 <span className="text-theme fs-4 fw-bold">00000</span>
//               </CardBody>
//             </Card>
//           </div>
//         </div>
//       </Loading>
//     </>
//   );
// };

// export default BalanceSheet;

import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { getBalanceSheet } from '@store/Finance/FinancialReports/FinancialReportsSlice';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { Card } from '@components/card/card';
import { useTranslation } from 'react-i18next';
import Loading from '@components/Shared/Loader/Loading';
import { Spinner, Alert } from 'react-bootstrap';

const BalanceSheet = () => {
  const dispatch = useAppDispatch();
  const { t, i18n } = useTranslation();
  const [filter, setFilter] = useState({ 
    startDate: '', 
    endDate: '' 
  });

  const { BalanceSheet: data, loading, error } = useAppSelector((s) => s.FinancialReports);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    dispatch(
      getBalanceSheet({
        startDate: filter.startDate,
        endDate: filter.endDate,
      })
    );
  };

  const resetFilters = () => {
    setFilter({
      startDate: '',
      endDate: ''
    });
  };

  const formatCurrency = (amount: number | null): string => {
    if (amount === null || amount === undefined) return '-';
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  };

  // استخراج البيانات الرئيسية
  const Assets = data?.list?.find((item) => item.accountNumber === '10000000');
  const Liabilities = data?.list?.find((item) => item.accountNumber === '20000000');
  const Equity = data?.list?.find((item) => item.accountNumber === '30000000');

  // حساب الإجماليات
  const calculateTotals = () => {
    const totalAssets = Assets?.amounT_DR || 0;
    const totalLiabilities = Liabilities?.amounT_CR || 0;
    const totalEquity = Equity?.amounT_CR || 0;
    const totalLiabilitiesEquity = totalLiabilities + totalEquity;
    const isBalanced = totalAssets === totalLiabilitiesEquity;

    return { totalAssets, totalLiabilities, totalEquity, totalLiabilitiesEquity, isBalanced };
  };

  const { totalAssets, totalLiabilities, totalEquity, totalLiabilitiesEquity, isBalanced } = calculateTotals();

  const BcrumbList = [
    {
      name: 'Home',
      link: ':moduleHome',
    },
    {
      name: 'المركــز المالي',
      link: null,
    },
  ];

  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb BreadcrumbList={BcrumbList} PageName="المركــز المالي" />
      </div>

      <Card className='mb-4'>
        <div className='card-header d-flex justify-content-between align-items-center'>
          <h6 className='mb-0'>
            <i className='fas fa-balance-scale me-2'></i>
            المركز المالي
            <span className='badge bg-primary ms-2'>التقرير المالي</span>
          </h6>
          <div>
            <span className='badge bg-success me-2'>
              الأصول: {formatCurrency(totalAssets)}
            </span>
            <span className='badge bg-warning me-2'>
              الخصوم: {formatCurrency(totalLiabilities)}
            </span>
            <span className={`badge ${isBalanced ? 'bg-success' : 'bg-danger'}`}>
              {isBalanced ? 'متوازن' : 'غير متوازن'}
            </span>
          </div>
        </div>

        <div className='card-body p-0'>
          {/* قسم الفلاتر */}
          <div className='p-3 border-bottom'>
            <div className='row mb-3'>
              <div className='col-lg-5 mb-2'>
                <div className='input-group flex-nowrap'>
                  <span className='input-group-text fw-bold'>من تاريـخ</span>
                  <input
                    type="date"
                    autoComplete="off"
                    className="form-control"
                    value={filter.startDate}
                    onChange={(e) => {
                      setFilter({ ...filter, startDate: e.target.value });
                    }}
                  />
                </div>
              </div>

              <div className='col-lg-5 mb-2'>
                <div className='input-group flex-nowrap'>
                  <span className='input-group-text fw-bold'>إلى تاريـخ</span>
                  <input
                    type="date"
                    autoComplete="off"
                    className="form-control"
                    value={filter.endDate}
                    onChange={(e) => {
                      setFilter({ ...filter, endDate: e.target.value });
                    }}
                  />
                </div>
              </div>

              <div className='col-lg-2 mb-2 d-flex gap-2'>
                <button className='btn btn-secondary flex-fill' onClick={resetFilters}>
                  إعادة تعيين
                </button>
                <button className='btn btn-theme flex-fill' onClick={fetchData} disabled={loading}>
                  {loading ? (
                    <>
                      <Spinner
                        as='span'
                        animation='border'
                        size='sm'
                        role='status'
                        aria-hidden='true'
                        className='me-2'
                      />
                      جاري التحميل...
                    </>
                  ) : (
                    'تحميل التقرير'
                  )}
                </button>
              </div>
            </div>

            {error && (
              <Alert variant='danger' className='mt-3 mb-0'>
                خطأ في تحميل البيانات: {error}
              </Alert>
            )}
          </div>

          {/* قسم النتائج */}
          <Loading loading={loading} error={error} Type="Dots">
            <div className="p-3">
              <div className="row d-flex align-items-stretch">
                {/* الأصول */}
                <div className="col-12 col-lg-6 mb-3">
                  <Card className="h-100 border-success">
                    <div className="card-header bg-success bg-opacity-10 border-success">
                      <h6 className="m-0 text-success">
                        <i className="fas fa-building me-2"></i>
                        {Assets?.name2 || 'الأصول'} 
                      </h6>
                    </div>
                    <div className="card-body p-0">
                      <div className="table-responsive">
                        <table className="table table-hover mb-0">
                          <thead className="table-success fw-bold">
                            <tr>
                              <th className="text-center small">كود الحساب</th>
                              <th className="text-center small">اسم الحساب</th>
                              <th className="text-center small">مدين (DR)</th>
                              <th className="text-center small">دائن (CR)</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Assets?.children?.map((category) => (
                              <React.Fragment key={category.id}>
                                <tr className="table-active fw-bold">
                                  <td className="text-center align-middle">
                                    <strong>{category.accountNumber}</strong>
                                  </td>
                                  <td className="align-middle">
                                    <strong>{i18n.language === 'ar' ? category.name2 : category.name}</strong>
                                  </td>
                                  <td className="text-center align-middle">
                                    <span className="badge bg-danger fs-6">
                                      {formatCurrency(category.amounT_DR)}
                                    </span>
                                  </td>
                                  <td className="text-center align-middle">
                                    <span className="badge bg-success fs-6">
                                      {formatCurrency(category.amounT_CR)}
                                    </span>
                                  </td>
                                </tr>
                                {category.children?.map((account) => (
                                  <tr key={account.id} className="table-light">
                                    <td className="text-center align-middle ps-4">
                                      <small>{account.accountNumber}</small>
                                    </td>
                                    <td className="align-middle ps-4">
                                      <small>{i18n.language === 'ar' ? account.name2 : account.name}</small>
                                    </td>
                                    <td className="text-center align-middle">
                                      <small className="text-muted">
                                        {formatCurrency(account.amounT_DR)}
                                      </small>
                                    </td>
                                    <td className="text-center align-middle">
                                      <small className="text-muted">
                                        {formatCurrency(account.amounT_CR)}
                                      </small>
                                    </td>
                                  </tr>
                                ))}
                              </React.Fragment>
                            ))}
                            {/* إجمالي الأصول */}
                            <tr className="fw-bold table-success">
                              <td colSpan={2} className="text-center align-middle fs-6">
                                إجمالي الأصول
                              </td>
                              <td className="text-center align-middle">
                                <span className="badge bg-danger fs-5">
                                  {formatCurrency(Assets?.amounT_DR)}
                                </span>
                              </td>
                              <td className="text-center align-middle">
                                <span className="badge bg-success fs-5">
                                  {formatCurrency(Assets?.amounT_CR)}
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Card>
                </div>

                {/* الخصوم وحقوق الملكية */}
                <div className="col-12 col-lg-6 mb-3">
                  <Card className="h-100 border-warning">
                    <div className="card-header bg-warning bg-opacity-10 border-warning">
                      <h6 className="m-0 text-warning">
                        <i className="fas fa-hand-holding-usd me-2"></i>
                        الخصوم وحقوق الملكية
                      </h6>
                    </div>
                    <div className="card-body p-0">
                      
                      {/* الخصوم */}
                      <div className="border-bottom">
                        <div className="table-responsive">
                          <table className="table table-hover mb-0">
                            <thead className="table-warning fw-bold">
                              <tr>
                                <th className="text-center small">كود الحساب</th>
                                <th className="text-center small">اسم الحساب</th>
                                <th className="text-center small">مدين (DR)</th>
                                <th className="text-center small">دائن (CR)</th>
                              </tr>
                            </thead>
                            <tbody>
                              {Liabilities?.children?.map((category) => (
                                <React.Fragment key={category.id}>
                                  <tr className="table-active fw-bold">
                                    <td className="text-center align-middle">
                                      <strong>{category.accountNumber}</strong>
                                    </td>
                                    <td className="align-middle">
                                      <strong>{i18n.language === 'ar' ? category.name2 : category.name}</strong>
                                    </td>
                                    <td className="text-center align-middle">
                                      <span className="badge bg-danger fs-6">
                                        {formatCurrency(category.amounT_DR)}
                                      </span>
                                    </td>
                                    <td className="text-center align-middle">
                                      <span className="badge bg-success fs-6">
                                        {formatCurrency(category.amounT_CR)}
                                      </span>
                                    </td>
                                  </tr>
                                  {category.children?.map((account) => (
                                    <tr key={account.id} className="table-light">
                                      <td className="text-center align-middle ps-4">
                                        <small>{account.accountNumber}</small>
                                      </td>
                                      <td className="align-middle ps-4">
                                        <small>{i18n.language === 'ar' ? account.name2 : account.name}</small>
                                      </td>
                                      <td className="text-center align-middle">
                                        <small className="text-muted">
                                          {formatCurrency(account.amounT_DR)}
                                        </small>
                                      </td>
                                      <td className="text-center align-middle">
                                        <small className="text-muted">
                                          {formatCurrency(account.amounT_CR)}
                                        </small>
                                      </td>
                                    </tr>
                                  ))}
                                </React.Fragment>
                              ))}
                              {/* إجمالي الخصوم */}
                              <tr className="fw-bold table-warning">
                                <td colSpan={2} className="text-center align-middle fs-6">
                                  إجمالي الخصوم
                                </td>
                                <td className="text-center align-middle">
                                  <span className="badge bg-danger fs-5">
                                    {formatCurrency(Liabilities?.amounT_DR)}
                                  </span>
                                </td>
                                <td className="text-center align-middle">
                                  <span className="badge bg-success fs-5">
                                    {formatCurrency(Liabilities?.amounT_CR)}
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      {/* حقوق الملكية */}
                      <div>
                        <div className="table-responsive">
                          <table className="table table-hover mb-0">
                            <thead className="table-info fw-bold">
                              <tr>
                                <th className="text-center small">كود الحساب</th>
                                <th className="text-center small">اسم الحساب</th>
                                <th className="text-center small">مدين (DR)</th>
                                <th className="text-center small">دائن (CR)</th>
                              </tr>
                            </thead>
                            <tbody>
                              {Equity?.children?.map((category) => (
                                <React.Fragment key={category.id}>
                                  <tr className="table-active fw-bold">
                                    <td className="text-center align-middle">
                                      <strong>{category.accountNumber}</strong>
                                    </td>
                                    <td className="align-middle">
                                      <strong>{i18n.language === 'ar' ? category.name2 : category.name}</strong>
                                    </td>
                                    <td className="text-center align-middle">
                                      <span className="badge bg-danger fs-6">
                                        {formatCurrency(category.amounT_DR)}
                                      </span>
                                    </td>
                                    <td className="text-center align-middle">
                                      <span className="badge bg-success fs-6">
                                        {formatCurrency(category.amounT_CR)}
                                      </span>
                                    </td>
                                  </tr>
                                  {category.children?.map((account) => (
                                    <tr key={account.id} className="table-light">
                                      <td className="text-center align-middle ps-4">
                                        <small>{account.accountNumber}</small>
                                      </td>
                                      <td className="align-middle ps-4">
                                        <small>{i18n.language === 'ar' ? account.name2 : account.name}</small>
                                      </td>
                                      <td className="text-center align-middle">
                                        <small className="text-muted">
                                          {formatCurrency(account.amounT_DR)}
                                        </small>
                                      </td>
                                      <td className="text-center align-middle">
                                        <small className="text-muted">
                                          {formatCurrency(account.amounT_CR)}
                                        </small>
                                      </td>
                                    </tr>
                                  ))}
                                </React.Fragment>
                              ))}
                              {/* إجمالي حقوق الملكية */}
                              <tr className="fw-bold table-info">
                                <td colSpan={2} className="text-center align-middle fs-6">
                                  إجمالي حقوق الملكية
                                </td>
                                <td className="text-center align-middle">
                                  <span className="badge bg-danger fs-5">
                                    {formatCurrency(Equity?.amounT_DR)}
                                  </span>
                                </td>
                                <td className="text-center align-middle">
                                  <span className="badge bg-success fs-5">
                                    {formatCurrency(Equity?.amounT_CR)}
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </Card>
                </div>
              </div>

              {/* الإجماليات النهائية */}
              <div className="row d-flex align-items-stretch mt-3">
                <div className="col-12 col-lg-6 mb-2">
                  <Card className="h-100 border-success">
                    <div className="card-body d-flex justify-content-between align-items-center py-3">
                      <span className="text-success fs-5 fw-bold">
                        <i className="fas fa-building me-2"></i>
                        إجمالي الأصول
                      </span>
                      <span className="text-success fs-4 fw-bold">
                        {formatCurrency(totalAssets)}
                      </span>
                    </div>
                  </Card>
                </div>

                <div className="col-12 col-lg-6 mb-2">
                  <Card className={`h-100 ${isBalanced ? 'border-success' : 'border-danger'}`}>
                    <div className="card-body d-flex justify-content-between align-items-center py-3">
                      <span className="text-muted fs-5 fw-bold">
                        <i className="fas fa-scale-balanced me-2"></i>
                        إجمالي الخصوم وحقوق الملكية
                      </span>
                      <span className={`fs-4 fw-bold ${isBalanced ? 'text-success' : 'text-danger'}`}>
                        {formatCurrency(totalLiabilitiesEquity)}
                        {isBalanced && <i className="fas fa-check-circle ms-2"></i>}
                        {!isBalanced && <i className="fas fa-exclamation-circle ms-2"></i>}
                      </span>
                    </div>
                  </Card>
                </div>
              </div>
            </div>
          </Loading>
        </div>

        <div className="card-footer d-flex justify-content-between align-items-center">
          <div className="text-muted small">
            فترة التقرير: {filter.startDate || 'بداية'} - {filter.endDate || 'نهاية'}
          </div>
          <div className="d-flex gap-3">
            <span className="text-success fw-bold">الأصول: {formatCurrency(totalAssets)}</span>
            <span className="text-warning fw-bold">الخصوم: {formatCurrency(totalLiabilities)}</span>
            <span className="text-info fw-bold">حقوق الملكية: {formatCurrency(totalEquity)}</span>
            <span className={`fw-bold ${isBalanced ? 'text-success' : 'text-danger'}`}>
              {isBalanced ? 'متوازن' : 'غير متوازن'}
            </span>
          </div>
        </div>
      </Card>
    </>
  );
};

export default BalanceSheet;